import React, { useEffect, useState } from 'react';
import { Heart, ShoppingCart, Loader2 } from 'lucide-react';
import { cartAPI, uploadsAPI } from '../services/api';
import { wishlistStore, useWishlistIds } from '../services/wishlistStore';
import { prodName } from '../services/catalogI18n';
import { fmtEuro } from '../services/shippingInfo';
import { useT } from '../services/i18n';

// Drawer empty state: wishlist items that can go back into the cart in one click
const CartDrawerWishlist = () => {
  const { t, lang } = useT();
  const ids = useWishlistIds();
  const [products, setProducts] = useState(null);
  const [adding, setAdding] = useState(null);
  const key = ids.join(',');
  useEffect(() => {
    if (!key) { setProducts([]); return; }
    let cancelled = false;
    wishlistStore.fetchProducts().then(p => !cancelled && setProducts(p || [])).catch(() => !cancelled && setProducts([]));
    return () => { cancelled = true; };
  }, [key]);
  if (!products?.length) return null;
  const add = async (p) => {
    setAdding(p.id);
    try { await cartAPI.addItem(p.id, 1); } catch (e) { /* toast by cartAPI */ } finally { setAdding(null); }
  };
  return (
    <section className="pb-4" data-testid="cart-drawer-wishlist">
      <h3 className="text-sm font-bold text-gray-900 flex items-center gap-2"><Heart size={15} className="text-orange-500" /> {t('cartDrawer.fromWishlist')}</h3>
      <ul className="mt-2 divide-y divide-gray-100">
        {products.slice(0, 5).map(p => (
          <li key={p.id} className="flex items-center gap-3 py-2" data-testid={`cart-drawer-wishlist-item-${p.id}`}>
            <div className="w-12 h-12 rounded-lg border border-gray-200 bg-white overflow-hidden flex items-center justify-center shrink-0">
              {p.image && <img src={uploadsAPI.resolveUrl(p.image)} alt="" className="w-full h-full object-contain" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-gray-900 line-clamp-2">{prodName(p, lang)}</p>
              <p className="text-xs font-bold text-gray-900">{fmtEuro(p.price)}</p>
            </div>
            <button type="button" onClick={() => add(p)} disabled={adding === p.id || (p.available_stock ?? p.stock ?? 1) <= 0} className="inline-flex items-center gap-1 text-xs font-medium rounded-lg px-2.5 py-1.5 bg-gray-900 text-white hover:bg-orange-600 disabled:opacity-40" data-testid={`cart-drawer-wishlist-add-${p.id}`}>
              {adding === p.id ? <Loader2 size={13} className="animate-spin" /> : <ShoppingCart size={13} />} {t('common.addToCart')}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CartDrawerWishlist;
